import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconInfoSolid24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="information solid">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM12 6C12.5523 6 13 6.44772 13 7C13 7.55228 12.5523 8 12 8C11.4477 8 11 7.55228 11 7C11 6.44772 11.4477 6 12 6ZM11 17V10H13V17H11Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
